import Mentor from "../../jsx/pages/Mentor";
import axiosInstance from "../AxiosInstance";
import {
  ABOUT,
  ADDEDUCATION,
  APPOINTMENTSREFERAL,
  BULK_QUESTIONS,
  BULKFILE,
  CASEREFERAL,
  CONTACTUS,
  DASHBOARDS_PEAK,
  DASHBOARDS_STATS,
  FAQ,
  FILEUPLAOD,
  LEGAL,
  MENTOR,
  PRIVACYPOLICY,
  PROMOTION,
  QUESTIONS,
  RESOURCES,
  SEARCH,
  SERVICE,
  SUBADMIN,
  SUBCATEGORY,
  SUBSCRIPTION_PLAN,
  ADMIN_EARNING,
  TERMSCONDITIONS,
} from "./adminEndpoints";

export function postServices(payload) {
  return axiosInstance.post(SERVICE, payload);
}
export function getServices(limit, page, search) {
  let url = `${SERVICE}`;
  const params = [];

  if (limit && limit !== "") {
    params.push(`limit=${encodeURIComponent(limit)}`);
  }

  if (page && page !== "") {
    params.push(`page=${encodeURIComponent(page)}`);
  }

  if (search && search.trim() !== "") {
    params.push(`search=${encodeURIComponent(search.trim())}`);
  }

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return axiosInstance.get(url);
}

export function deleteServices(id) {
  return axiosInstance.delete(`${SERVICE}?serviceId=${id}`);
}

export function editServices(payload) {
  return axiosInstance.put(SERVICE, payload);
}

export function getFaQs(page, limit, search) {
  let url = `${FAQ}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function deleteFaQs(id) {
  return axiosInstance.delete(`${FAQ}?faqId=${id}`);
}

export function editFAQ(payload) {
  return axiosInstance.put(FAQ, payload);
}

export function addFAQ(payload) {
  return axiosInstance.post(FAQ, payload);
}

export function getInfo() {
  return axiosInstance.get(LEGAL);
}

export function createInfo(payload) {
  return axiosInstance.post(LEGAL, payload);
}

export function getResources() {
  return axiosInstance.get(RESOURCES);
}

export function createResources(payload) {
  return axiosInstance.post(RESOURCES, payload);
}

export function addFile(payload) {
  return axiosInstance.post(FILEUPLAOD, payload);
}

export function addEducation(payload) {
  return axiosInstance.post(ADDEDUCATION, payload);
}

export function getEducation(page, limit, type, search) {
  let url = `${ADDEDUCATION}?page=${page}&limit=${limit}&type=${type}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function deleteEducation(id) {
  return axiosInstance.delete(`${ADDEDUCATION}?educationId=${id}`);
}

export function updateEducation(payload) {
  return axiosInstance.put(ADDEDUCATION, payload);
}

export function getPrivayPolicy() {
  return axiosInstance.get(PRIVACYPOLICY);
}

export function createPrivayPolicy(payload) {
  return axiosInstance.post(PRIVACYPOLICY, payload);
}
export function deletePrivayPolicy(id) {
  return axiosInstance.delete(`${PRIVACYPOLICY}?privacyId=${id}`);
}

export function updatePrivayPolicy(payload) {
  return axiosInstance.put(PRIVACYPOLICY, payload);
}

export function getTermsConditions() {
  return axiosInstance.get(TERMSCONDITIONS);
}

export function createTermsConditions(payload) {
  return axiosInstance.post(TERMSCONDITIONS, payload);
}
export function deleteTermsConditions(id) {
  return axiosInstance.delete(`${TERMSCONDITIONS}?termId=${id}`);
}

export function updateTermsConditions(payload) {
  return axiosInstance.put(TERMSCONDITIONS, payload);
}

export function getAbout() {
  return axiosInstance.get(ABOUT);
}

export function createAbout(payload) {
  return axiosInstance.post(ABOUT, payload);
}
export function deleteAbout(id) {
  return axiosInstance.delete(`${ABOUT}?aboutId=${id}`);
}

export function updateAbout(payload) {
  return axiosInstance.put(ABOUT, payload);
}

export function getPromotion(page, limit, search) {
  let url = `${PROMOTION}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function createPromotion(payload) {
  return axiosInstance.post(PROMOTION, payload);
}
export function deletePromotion(id) {
  return axiosInstance.delete(`${PROMOTION}?promotionId=${id}`);
}

export function updatePromotion(payload) {
  return axiosInstance.put(PROMOTION, payload);
}

export function getSearch(page, limit, search) {
  let url = `${SEARCH}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function createSearch(payload) {
  return axiosInstance.post(SEARCH, payload);
}
export function deleteSearch(id) {
  return axiosInstance.delete(`${SEARCH}?categoryId=${id}`);
}

export function updateSearch(payload) {
  return axiosInstance.put(SEARCH, payload);
}

export function getSub(id, page, limit, search) {
  let url = `${SUBCATEGORY}?categoryId=${id}&page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function createSub(payload) {
  return axiosInstance.post(SUBCATEGORY, payload);
}
export function deleteSub(id) {
  return axiosInstance.delete(`${SUBCATEGORY}?subCategoryId=${id}`);
}

export function updateSub(payload) {
  return axiosInstance.put(SUBCATEGORY, payload);
}

export function getQuestions(id, type, page, limit, search) {
  let url = `${QUESTIONS}?subCategoryId=${id}&type=${type}&page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function createQuestions(payload) {
  return axiosInstance.post(QUESTIONS, payload);
}
export function deleteQuestions(id) {
  return axiosInstance.delete(`${QUESTIONS}?questionId=${id}`);
}

export function updateQuestions(payload) {
  return axiosInstance.put(QUESTIONS, payload);
}

export function getReferal(page, limit, search) {
  let url = `${CASEREFERAL}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function getReferalDetail(id) {
  let url = `admin/case-referral/details?id=${id}`;

  return axiosInstance.get(url);
}

export function updateReferalDetail(payload) {
  let url = `${CASEREFERAL}/update-status`;

  return axiosInstance.put(url, payload);
}

export function getAppointments(
  page,
  limit,
  search,
  statusFilter,
  startDate,
  endDate,
  serviceDepartment,
) {
  let url = `${APPOINTMENTSREFERAL}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (statusFilter) {
    url += `&status=${encodeURIComponent(statusFilter)}`;
  }

  if (startDate) {
    url += `&startDate=${encodeURIComponent(startDate)}`;
  }

  if (endDate) {
    url += `&endDate=${encodeURIComponent(endDate)}`;
  }

  if (serviceDepartment) {
    url += `&serviceDepartment=${encodeURIComponent(serviceDepartment)}`;
  }
  return axiosInstance.get(url);
}

export function getAppointmentsById(id) {
  let url = `${APPOINTMENTSREFERAL}/details?appointmentId=${id}`;

  // if (search && search.trim() !== "") {
  //   url += `&search=${encodeURIComponent(search)}`;
  // }
  return axiosInstance.get(url);
}

export function updateAppointentStatus(paylaod) {
  let url = `${APPOINTMENTSREFERAL}`;

  // if (search && search.trim() !== "") {
  //   url += `&search=${encodeURIComponent(search)}`;
  // }
  return axiosInstance.put(url, paylaod);
}

export function getSTATS(service, start, end) {
  let url = `${DASHBOARDS_STATS}`;
  const params = [];

  if (service) params.push(`serviceDepartment=${service}`);
  if (start) params.push(`startDate=${start}`);
  if (end) params.push(`endDate=${end}`);

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return axiosInstance.get(url);
}

export function getPEAK(groupBy, start, end) {
  let url = `${DASHBOARDS_PEAK}`;
  const params = [];

  if (groupBy) params.push(`groupBy=${groupBy}`);
  if (start) params.push(`startDate=${start}`);
  if (end) params.push(`endDate=${end}`);

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return axiosInstance.get(url);
}

//getDepartments
export function getDepartments() {
  let url = `admin/department`;
  return axiosInstance.get(url);
}

//get SubAdmin
export function getSubAdmins(page, limit, search, sortBy, start, end) {
  let url = `${SUBADMIN}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (sortBy && sortBy.trim() !== "") {
    url += `&isInternalUser=${encodeURIComponent(sortBy)}`;
  }
  if (start) {
    url += `&startDate=${encodeURIComponent(start)}`;
  }
  if (end) {
    url += `&endDate=${encodeURIComponent(end)}`;
  }
  return axiosInstance.get(url);
}
export function updateAdminStatus(payload) {
  let url = `${SUBADMIN}/block-unblock`;
  return axiosInstance.put(url, payload);
}

export function createNewAdmin(payload) {
  let url = `${SUBADMIN}`;
  return axiosInstance.post(url, payload);
}
export function updateAdminInfo(payload) {
  let url = `${SUBADMIN}`;
  return axiosInstance.put(url, payload);
}

export function deleteAdmin(id) {
  let url = `${SUBADMIN}?userId=${id}`;
  return axiosInstance.delete(url);
}

export function updatePermission(payload) {
  let url = `${SUBADMIN}/update-permissions`;
  return axiosInstance.put(url, payload);
}


//mentor
export function getMentor(page, limit, search) {
  let url = `${MENTOR}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}
export function addMentor(payload) {
  let url = `${MENTOR}`;
  return axiosInstance.post(url, payload);
}
export function deleteMentor(id) {
  let url = `${MENTOR}?mentorsId=${id}`;
  return axiosInstance.delete(url);
}
export function updateMentor(payload) {
  let url = `${MENTOR}`;
  return axiosInstance.put(url, payload);
}

//contact us
export function getContactus(page, limit, search) {
  let url = `${CONTACTUS}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function uploadBulkUsers(payload) {
  let url = `${BULKFILE}`;
  return axiosInstance.post(url, payload);
}

export function uploadPdf(payload) {
  let url = `${BULK_QUESTIONS}`;
  return axiosInstance.post(url, payload);
}

// Subscription Plans
export function getSubscriptionPlans(page = 0, limit = 10, search = "") {
  let url = `${SUBSCRIPTION_PLAN}?page=${page}&limit=${limit}`;
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search.trim())}`;
  }
  return axiosInstance.get(url);
}

export function createSubscriptionPlan(payload) {
  return axiosInstance.post(SUBSCRIPTION_PLAN, payload);
}

export function getSubscriptionPlanDetails(subscriptionPlanId) {
  return axiosInstance.get(`${SUBSCRIPTION_PLAN}/details?subscriptionPlanId=${encodeURIComponent(subscriptionPlanId)}`);
}

export function updateSubscriptionPlan(payload) {
  return axiosInstance.put(SUBSCRIPTION_PLAN, payload);
}

export function deleteSubscriptionPlan(subscriptionPlanId) {
  return axiosInstance.delete(`${SUBSCRIPTION_PLAN}?subscriptionPlanId=${encodeURIComponent(subscriptionPlanId)}`);
}

// Admin Earning Services
export function getEarnings(
  page = 0,
  limit = 10,
  search = "",
  status = "",
  planId = "",
  startDate = "",
  endDate = ""
) {
  const params = [];
  params.push(`page=${encodeURIComponent(page)}`);
  params.push(`limit=${encodeURIComponent(limit)}`);
  if (search && search.trim() !== "") params.push(`search=${encodeURIComponent(search.trim())}`);
  if (status && status !== "all") params.push(`status=${encodeURIComponent(status)}`);
  if (planId && planId !== "all") params.push(`planId=${encodeURIComponent(planId)}`);
  if (startDate) params.push(`startDate=${encodeURIComponent(startDate)}`);
  if (endDate) params.push(`endDate=${encodeURIComponent(endDate)}`);

  const url = `${ADMIN_EARNING}?${params.join("&")}`;
  return axiosInstance.get(url);
}

export function getEarningStats(startDate = "", endDate = "") {
  const params = [];
  if (startDate) params.push(`startDate=${encodeURIComponent(startDate)}`);
  if (endDate) params.push(`endDate=${encodeURIComponent(endDate)}`);
  const queryStr = params.length > 0 ? `?${params.join("&")}` : "";
  return axiosInstance.get(`${ADMIN_EARNING}/stats${queryStr}`);
}

export function getEarningDetails(earningId) {
  return axiosInstance.get(`${ADMIN_EARNING}/details?earningId=${encodeURIComponent(earningId)}`);
}

export function getEarningGraph(startDate = "", endDate = "", planId = "", period = "weekly") {
  const params = [];
  if (startDate) params.push(`startDate=${encodeURIComponent(startDate)}`);
  if (endDate) params.push(`endDate=${encodeURIComponent(endDate)}`);
  if (planId && planId !== "all") params.push(`planId=${encodeURIComponent(planId)}`);
  if (period) params.push(`period=${encodeURIComponent(period)}`);

  const queryStr = params.length > 0 ? `?${params.join("&")}` : "";
  return axiosInstance.get(`${ADMIN_EARNING}/graph${queryStr}`);
}




